import React, { useContext, useState, useEffect } from "react";
import { Context } from "..";
import { cancelPosting, getPostings } from "../http/userAPI";
import { Container, Table, Button, Tabs, Tab, Spinner, Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { Pencil, X } from "react-bootstrap-icons"; // иконки

const History = observer(() => {
  const { user, product } = useContext(Context);
  const [activePostings, setActivePostings] = useState([]);
  const [deliveredPostings, setDeliveredPostings] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPostings = async () => {
      try {
        setLoading(true);
        const [active, delivered] = await Promise.all([
          getPostings(user, true),
          getPostings(user, false),
        ]);
        setActivePostings(active);
        setDeliveredPostings(delivered);
      } catch (error) {
        console.error("Ошибка загрузки заказов:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPostings();
  }, [product.reload]);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth < 768);
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  const renderPostingsTable = (postings, showActions = false) => {
  if (isMobile) {
    return (
      <div className="d-flex flex-column gap-3 mt-3">
        {postings.map((posting) => (
          <div key={posting.number} className="border rounded p-3 shadow-sm bg-light">
            <div><strong>Номер заказа:</strong> {posting.number}</div>
            <div><strong>Статус:</strong> {posting.status}</div>
            <div><strong>Адрес:</strong> {posting.address}</div>
            <div><strong>Дата:</strong> {posting.date}</div>
            <div className="mt-2">
              <strong>Товары:</strong>
              <ul className="mb-2 ps-3">
                {posting.products.map((p, i) => (
                  <li key={i}>
                    {p.article} — {p.count} шт
                  </li>
                ))}
              </ul>
            </div>
            {showActions &&
              (posting.status === "Необходимо отгрузить" ||
               posting.status === "Новый" ||
               posting.status === "Необходимо обработать") && (
              <div className="d-flex gap-2">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => navigate(`/posting/${posting.number}`)}
                >
                  Изменить
                </Button>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() =>
                    cancelPosting(user, posting.number).then(() =>
                      product.setReload(product.reload + 1)
                    )
                  }
                >
                  Отменить
                </Button>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }

  // 🌐 Для десктопа — таблица
  return (
    <Table hover responsive className="align-middle mt-3">
      <thead>
        <tr>
          <th>Номер заказа</th>
          <th>Товар</th>
          <th>Количество</th>
          <th className="d-none d-md-table-cell">Статус</th>
          <th className="d-none d-md-table-cell">Адрес</th>
          <th className="d-none d-md-table-cell">Дата</th>
          {showActions && <th colSpan={2}></th>}
        </tr>
      </thead>
      <tbody>
        {postings
          .filter((posting) => posting.products.length > 0)
          .map((posting) => (
            <React.Fragment key={posting.number}>
              <tr>
                <td rowSpan={posting.products.length}>{posting.number}</td>
                <td>{posting.products[0].article}</td>
                <td>{posting.products[0].count}</td>
                <td rowSpan={posting.products.length} className="d-none d-md-table-cell">
                  {posting.status}
                </td>
                <td rowSpan={posting.products.length} className="d-none d-md-table-cell">
                  {posting.address}
                </td>
                <td rowSpan={posting.products.length} className="d-none d-md-table-cell">
                  {posting.date}
                </td>
                {showActions &&
                  (posting.status === "Необходимо отгрузить" || posting.status === "Новый" ||
                    posting.status === "Необходимо обработать") && (
                    <>
                      <td rowSpan={posting.products.length}>
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          onClick={() => navigate(`/posting/${posting.number}`)}
                        >
                          Изменить
                        </Button>
                      </td>
                      <td rowSpan={posting.products.length}>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() =>
                            cancelPosting(user, posting.number).then(() =>
                              product.setReload(product.reload + 1)
                            )
                          }
                        >
                          Отменить
                        </Button>
                      </td>
                    </>
                  )}
              </tr>
              {posting.products.slice(1).map((p, index) => (
                <tr key={index}>
                  <td>{p.article}</td>
                  <td>{p.count}</td>
                </tr>
              ))}
            </React.Fragment>
          ))}
      </tbody>
    </Table>
  );
};

/*
const renderPostingsTable = (postings, showActions = false) => (
  <Table bordered hover responsive className="align-middle">
    <thead className="table-light">
      <tr>
        <th>№ заказа</th>
        <th>Товар</th>
        <th>Кол-во</th>
        <th>Статус</th>
        <th>Адрес</th>
        <th>Дата</th>
        {showActions && <th colSpan={2}>Действия</th>}
      </tr>
    </thead>
    <tbody>
      {postings
        .filter((posting) => posting.products.length > 0)
        .map((posting) => (
          <React.Fragment key={posting.number}>
            <tr>
              <td rowSpan={posting.products.length}>{posting.number}</td>
              <td>{posting.products[0].article}</td>
              <td>{posting.products[0].count}</td>
              <td rowSpan={posting.products.length}>
                <Badge bg={getStatusColor(posting.status)}>{posting.status}</Badge>
              </td>
              <td rowSpan={posting.products.length}>{posting.address}</td>
              <td rowSpan={posting.products.length}>{posting.date}</td>
              {showActions &&
                (posting.status === "Необходимо отгрузить" ||
                  posting.status === "Необходимо обработать") && (
                  <>
                    <td rowSpan={posting.products.length}>
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={() => navigate(`/posting/${posting.number}`)}
                      >
                        <Pencil size={16} /> Изменить
                      </Button>
                    </td>
                    <td rowSpan={posting.products.length}>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() =>
                          cancelPosting(user, posting.number).then(() =>
                            product.setReload(product.reload + 1)
                          )
                        }
                      >
                        <X size={16} /> Отменить
                      </Button>
                    </td>
                  </>
                )}
            </tr>
            {posting.products.slice(1).map((p, index) => (
              <tr key={index}>
                <td>{p.article}</td>
                <td>{p.count}</td>
              </tr>
            ))}
          </React.Fragment>
        ))}
    </tbody>
  </Table>
);

const getStatusColor = (status) => {
  switch (status) {
    case "Необходимо отгрузить":
      return "success";
    case "Необходимо обработать":
      return "warning";
    case "Отменён":
      return "danger";
    default:
      return "secondary";
  }
};*/

  return (
    <Container>
      <h1 className="mt-3">История заказов</h1>
      {loading ? (
        <div className="text-center mt-4">
          <Spinner animation="border" role="status" />
        </div>
      ) : (
        <Tabs defaultActiveKey="active" className="mt-4">
          <Tab eventKey="active" title="Активные заказы">
            {activePostings.length > 0 ? (
              renderPostingsTable(activePostings, true)
            ) : (
              <p className="mt-3">У вас нет активных заказов</p>
            )}
          </Tab>
          <Tab eventKey="delivered" title="Закрытые заказы">
            {deliveredPostings.length > 0 ? (
              renderPostingsTable(deliveredPostings)
            ) : (
              <p className="mt-3">У вас нет закрытых заказов</p>
            )}
          </Tab>
        </Tabs>
      )}
    </Container>
  );
});

export default History;
